import React from "react";

export default function SectionCard({ icon: Icon, title, right, children }) {
  return (
    <div className="rounded-2xl border border-gray-100 bg-white shadow-sm">
      <div className="flex items-center justify-between border-b px-4 py-3 sm:px-6">
        <div className="flex items-center gap-2">
          {Icon ? (
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-50 text-emerald-600">
              <Icon size={18} />
            </span>
          ) : null}
          <h3 className="text-base font-semibold text-gray-900">{title}</h3>
        </div>
        {right}
      </div>
      <div className="p-4 sm:p-6">{children}</div>
    </div>
  );
}
